import { AssetTypes } from "@zapier/utils";

export interface ConnectedAsset {
  id: string | number;
  title?: string | null;
  type: AssetTypes;
  updatedAt?: string | null;
}

interface CanvasConnection {
  id: string | number;
  name: string;
  updatedAt?: string | null;
}

export function transformCanvasConnections(
  canvases: CanvasConnection[] | undefined,
): ConnectedAsset[] {
  return (
    canvases?.map((canvas) => ({
      id: canvas.id,
      title: canvas.name,
      type: AssetTypes.Canvas,
      updatedAt: canvas.updatedAt,
    })) || []
  );
}

interface InterfaceConnection {
  interfacesProjectId: string | number;
  interfacesProjectName: string;
}

export function transformInterfaceConnections(
  interfaceObjects: InterfaceConnection[] | undefined,
): ConnectedAsset[] {
  return (
    interfaceObjects?.map((interfaceObject) => ({
      id: interfaceObject.interfacesProjectId,
      title: interfaceObject.interfacesProjectName,
      type: AssetTypes.Interface,
    })) || []
  );
}

interface ChatbotConnection {
  id: string | number;
  name: string;
  updatedAt?: string | null;
}

export function transformChatbotConnections(
  chatbots: ChatbotConnection[] | undefined,
): ConnectedAsset[] {
  return (
    chatbots?.map((chatbot) => ({
      id: chatbot.id,
      title: chatbot.name,
      type: AssetTypes.Chatbot,
      updatedAt: chatbot.updatedAt,
    })) || []
  );
}

interface ZapConnection {
  id: string | number;
  title?: string | null;
  updatedAt?: string | null;
}

export function transformZapConnections(
  zaps: ZapConnection[] | undefined,
): ConnectedAsset[] {
  return (
    zaps?.map((zap) => ({
      id: zap.id,
      title: zap.title,
      type: AssetTypes.Zap,
      updatedAt: zap.updatedAt,
    })) || []
  );
}

interface SubscriptionConnection {
  id: string | number;
  connectedZapId?: string | number | null;
}

export function transformSubscriptionConnections(
  subscriptions: SubscriptionConnection[] | undefined,
): ConnectedAsset[] {
  return (
    subscriptions?.map((subscription) => ({
      id: subscription.connectedZapId || subscription.id,
      type: AssetTypes.TableSubscription,
    })) || []
  );
}

interface TableViewConnection {
  id: string | number;
  name: string;
  editedAt?: string | null;
}

export function transformTableViewConnections(
  tableViews: TableViewConnection[] | undefined,
): ConnectedAsset[] {
  return (
    tableViews?.map((tableView) => ({
      id: tableView.id,
      title: tableView.name,
      type: AssetTypes.TableView,
      updatedAt: tableView.editedAt,
    })) || []
  );
}
